export default __webpack_public_path__ + "assets/images/d2a49b5eb86f8d4209220d548eee8cd4.svg";